type TCallbacks = Set<Function>;
type TEvents = Map<string, TCallbacks>;
export class CommunicatorService {
  private events: TEvents;

  constructor() {
    this.events = new Map();
  }
  protected __getEvents(eventName: string): TCallbacks {
    return this.events.get(eventName) as TCallbacks;
  }

  subscribe(eventName: string, callBack: Function) {
    if (!this.events.has(eventName)) {
      this.events.set(eventName, new Set());
    }
    this.__getEvents(eventName).add(callBack);
    return {
      release: this.release.bind(this, eventName, callBack)
    };
  }

  release(eventName: string, callBack: Function) {
    this.__getEvents(eventName).delete(callBack);
  }

  publish(eventName: string) {
    if (this.__getEvents(eventName) instanceof Set) {
      this.__getEvents(eventName).forEach((callBack) => callBack());
    } else {
      console.warn('Communicator service: publish method got called before registering the event');
    }
  }
}



// WEBPACK FOOTER //
// ./app/vendor/ui-ng-component-communicator/src/lib/communicator.ts